import React, { useEffect } from "react";
import styles from "./styles.module.scss";
import SimpleLayout from "layouts/simple/simple";
import { useAppStore } from "store";
import { generatePath, useHistory } from "react-router-dom";
import { Routes } from "routes";

const NoAccessPage = () => {
	// Temporary solution to not allow AI API Admin to see this page
	const { usersStore } = useAppStore();
	const {isAiApiAdmin} = usersStore;

	const history = useHistory();

	useEffect(() => {
		if(isAiApiAdmin) {
				history.push(generatePath(Routes.Reports));
		}
	}, [ isAiApiAdmin, history ]);

	return (
		<SimpleLayout>
			<div className={styles.no_access}>Sorry, you are not allowed to access this page</div>
		</SimpleLayout>
	);
};

export default NoAccessPage;
